import { gql } from "@apollo/client";

export const productMasterData = {
  brandCode: "",
  productCode: "",
  productName: "",
  productCategory: "",
  productBrand: "",
  productUom: "",
  baseUom: "",
  conversion: "",
  vat: "",
  bas: "",
  cod: "",
  csh: "",
  smt: "",
  vansl: "",
  productImage: null,

  brandCodeStatus: "unchecked",
  productCodeStatus: "unchecked",
  productNameStatus: "unchecked",
  productCategoryStatus: "unchecked",
  productBrandStatus: "unchecked",
  productUomStatus: "unchecked",
  baseUomStatus: "unchecked",
  conversionStatus: "unchecked",
  vatStatus: "unchecked",
  basStatus: "unchecked",
  codStatus: "unchecked",
  cshStatus: "unchecked",
  smtStatus: "unchecked",
  vanslStatus: "unchecked",
  productImageStatus: false,
};

export const productDataMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;
  switch (inputName) {
    case "productCode": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productCode: value,
          productCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productCode: "",
          productCodeStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productCode: value,
          productCodeStatus: "error",
        };
      }
    }
    case "productName": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productName: value,
          productNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productName: "",
          productNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productName: value,
          productNameStatus: "error",
        };
      }
    }
    case "productBrand": {
      if (value) {
        return {
          ...state,
          productBrand: value,
          productBrandStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productBrand: "",
          productBrandStatus: "unchecked",
        };
      }
    }
    case "brandCode": {
      if (value) {
        return {
          ...state,
          brandCode: value,
          brandCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          brandCode: "",
          brandCodeStatus: "unchecked",
        };
      }
    }
    case "productCategory": {
      if (value) {
        return {
          ...state,
          productCategory: value,
          productCategoryStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productCategory: "",
          productCategoryStatus: "unchecked",
        };
      }
    }
    case "productUom": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productUom: value,
          productUomStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productUom: "",
          productUomStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productUom: value,
          productUomStatus: "error",
        };
      }
    }
    case "baseUom": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          baseUom: value,
          baseUomStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          baseUom: "",
          baseUomStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          baseUom: value,
          baseUomStatus: "error",
        };
      }
    }
    case "conversion": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          conversion: value,
          conversionStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          conversion: "",
          conversionStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          conversion: value,
          conversionStatus: "error",
        };
      }
    }
    case "bas": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          bas: value,
          basStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          bas: "",
          basStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          bas: value,
          basStatus: "error",
        };
      }
    }
    case "cod": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          cod: value,
          codStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          cod: "",
          codStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          cod: value,
          codStatus: "error",
        };
      }
    }
    case "smt": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          smt: value,
          smtStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          smt: "",
          smtStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          smt: value,
          smtStatus: "error",
        };
      }
    }
    case "csh": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          csh: value,
          cshStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          csh: "",
          cshStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          csh: value,
          cshStatus: "error",
        };
      }
    }
    case "vat": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          vat: value,
          vatStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          vat: "",
          vatStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          vat: value,
          vatStatus: "error",
        };
      }
    }
    case "vansl": {
      const alphaNLenghthRegex = new RegExp("^.{1,1000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          vansl: value,
          vanslStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          vansl: "",
          vanslStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          vansl: value,
          vanslStatus: "error",
        };
      }
    }
    case "productImage": {
      if (value) {
        return {
          ...state,
          productImage: value,
          productImageStatus: true,
        };
      } else if (!value) {
        return {
          ...state,
          productImage: null,
          productImageStatus: false,
        };
      }
    }

    default:
      return state;
  }
};

export const createProductMaster = gql`
  mutation createproduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      success

      message
    }
  }
`;

export const getProductById = gql`
  query GetProductById($id: Int!) {
    getProductById(id: $id) {
      success

      error

      message

      data {
        id

        productCode

        productName

        productCategory

        productBrandCode

        productBrand

        productUom

        baseUom

        conversion

        vat

        bas

        cod

        csh

        smt

        vansl

        createdAt

        lastupdate
      }
    }
  }
`;

export const updateProductMaster = gql`
  mutation updateproduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      success

      message
    }
  }
`;

export const allProducts = gql`
  query GetAllProducts($page: Int, $pageSize: Int, $search: String) {
    allProducts(page: $page, pageSize: $pageSize, search: $search) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        productCode
        productName
        productCategory
        productBrand
        productBrandCode
        productUom
        baseUom
        conversion
        vat
        bas
        cod
        csh
        smt
        vansl
        createdAt
        lastupdate
        user {
          employeeName
        }
      }
    }
  }
`;

export const uploadProductMaster = gql`
  mutation uploadProductMaster($file: Upload!, $userId: Int!) {
    uploadProductMaster(file: $file, userId: $userId) {
      success
      message
    }
  }
`;

export const exportProductMaster = gql`
  mutation {
    exportProductMaster {
      success
      fileUrl
    }
  }
`;

export const deleteProduct = gql`
  mutation deleteproduct($id: ID!) {
    deleteProduct(id: $id) {
      success
      message
    }
  }
`;
